class Dropdown {
    constructor(el) {
        this.isOpen = false;
        this.el = el;
        this.single_select = el.hasAttribute('data-dropdown-single-select');
        var tabindexes = el.querySelectorAll('[tabindex]');

        el.querySelector('[data-control="dropdown-header"]').addEventListener(
            "click",
            e => {
                e.stopPropagation();
                this.toggle();
            }
        );

        el.querySelector('[data-control="dropdown-header"]').addEventListener(
            "keyup",
            e => {
                if (e.key === 'Enter' || e.keyCode === 13) {
                    e.stopPropagation();
                    this.toggle();
                }
            }
        );

        el.querySelector('[data-control="dropdown-body"]').addEventListener(
            "keyup",
            e => {
                if (e.key === 'Enter' || e.keyCode === 13) {
                    this.toggle();
                }
            }
        );

        el.querySelector('[data-control="dropdown-body"]').addEventListener(
            "mouseup",
            e => {
                if (!this.single_select) {
                    e.stopPropagation();
                }
            }
        );

        tabindexes.forEach(tabindex => {
            tabindex.addEventListener(
                "blur",
                e => {
                    if(!this.el.contains(e.relatedTarget) && e.relatedTarget?.hasAttribute('tabindex')) {
                        this.force_close();
                    }
                }
            );
        });

        document.addEventListener("mouseup", (e) => {
            if(e.target.dataset.control === 'dropdown-header' && this.el.contains(e.target)) {
                return;
            }

            this.force_close();
        });
    }

    toggle() {
        //close all dropdowns
        document.querySelectorAll('[data-control="dropdown"]').forEach(el => {
            this.force_close(el);
        });

        //open this dropdown
        if (this.isOpen === true) {
            this.close_dropdown();
        }
        else {
            this.open_dropdown();
        }
    }

    close_dropdown() {
        this.el.classList.remove("open");
        this.isOpen = false;
        this.set_input_tabindexes(this.el, false);

        this.el.querySelector('[data-control="dropdown-header"]')?.focus()
    }

    open_dropdown() {
        this.el.classList.add("open");
        this.isOpen = true;
        this.set_input_tabindexes(this.el, true);

        this.el.querySelector('[data-control="dropdown-body"] [tabindex]')?.focus()
    }

    force_close(el = null) {
        if (el === null) {
            this.el.classList.remove("open");
            this.isOpen = false;
            this.set_input_tabindexes(this.el, false);
        }
        else {
            el.classList.remove("open");
            el.isOpen = false;
            this.set_input_tabindexes(el, false);
        }
    }

    set_input_tabindexes(el, set) {
        var input_list = el.querySelectorAll('[data-control="dropdown-body"] [tabindex]');

        input_list.forEach(function(input) {
            input.setAttribute('tabindex', set ? '0' : '-1');
        })
    }
}

export { Dropdown as default };
